import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { DATE_FORMAT } from "@/Utils/DateUtils";

dayjs.extend(isSameOrBefore);

export const getDatesBetween = (
  startDate: string,
  stopDate: string,
): string[] => {
  const dates: string[] = [];

  let currentStartDate = dayjs(startDate);

  const currentStopDate = dayjs(stopDate);

  while (currentStartDate.isSameOrBefore(currentStopDate)) {
    dates.push(currentStartDate.format(DATE_FORMAT));

    currentStartDate = currentStartDate.add(1, "day");
  }

  return dates;
};
